import type { ReactNode } from 'react'

/**
 * The three glyphs of the masthead's theme switch — a monitor (System), a sun (Light) and a moon
 * (Dark) — and the only icons this console draws (docs/ux/PLATFORM-ADMIN.md §5.2 allows exactly these).
 *
 * Each is an inline SVG on a 24-unit grid, stroked with `currentColor` and filled with nothing, so
 * its colour comes from the token the surrounding rule sets and from nothing here (the no-literal
 * gate in `styles.test.ts` would not see a colour written inside a component, so there is none to
 * see). They are decoration: the option they sit in is named by its label, so they are `aria-hidden`
 * and not focusable.
 */
function Glyph({ children }: { readonly children: ReactNode }) {
  return (
    <svg
      className="segment-icon"
      viewBox="0 0 24 24"
      width="18"
      height="18"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {children}
    </svg>
  )
}

export function MonitorIcon() {
  return (
    <Glyph>
      <rect x="3" y="4" width="18" height="12" rx="2" />
      <path d="M8 20h8M12 16v4" />
    </Glyph>
  )
}

export function SunIcon() {
  return (
    <Glyph>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
    </Glyph>
  )
}

export function MoonIcon() {
  return (
    <Glyph>
      <path d="M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5Z" />
    </Glyph>
  )
}
